import React, { Component } from 'react'
import Radium from 'radium'
import { Scrollbars } from 'react-custom-scrollbars'
import { connect } from 'react-redux'
import Waves from 'node-waves'

import Tabbar from './tabbar/tabbar'
import Images from '../Images/index2'
import StaticDailyReport from '../DailyReport/staticDailyReport2';
import StaticInvoice from './staticInvoice'

import { semanticColors } from '../../../Globals/styles'
import HeadingSubtextContainer from '../../../HeadingSubtext/HeadingSubtextContainer'
import PricelistsList from '../../../PricelistsList/index'
import DatePickerRange from '../../../Common/datepickerRange2'



import Offers from './spreadsheets/offers'
import Others from './spreadsheets/others'
import Crew from './spreadsheets/crew'
import Activity from './spreadsheets/activity'
import Materiel from './spreadsheets/materiel'
import Measurements from './spreadsheets/measurements'
import DeliveryNotes from './spreadsheets/deliveryNotes'
import Invoices from './spreadsheets/invoices'


import InvoiceSummary from './summary'

import { attemptGetWorkplace } from '../Overview/actions'
import * as actions from './actions'

class Invoice extends Component {
    constructor(props) {
        super(props)
        this.state = {
            activeTab: 0,
            dailySel: {},
            hide: true,
            prev: []
        }
    }
    componentDidMount = () => {
        Waves.attach('.waves-btn', ['waves-button']);
        Waves.attach('.waves-icon', ['waves-circle']);
        this.props.dispatch({ type: 'PREV_IS_LOADING', status: true })
        actions.getPrevInvoices(this.props.params.workplaceId)
            .then((e) => {
                this.setState({
                    prev: e
                })
                this.props.dispatch({ type: 'PREV_IS_LOADING', status: false })
            })
    };
    componentDidUpdate = (prevProps, prevState) => {
        Waves.attach('.waves-btn', ['waves-button']);
        Waves.attach('.waves-icon', ['waves-circle']);
    };
    componentWillMount = () => {
        const { params, dispatch } = this.props;
        dispatch(attemptGetWorkplace(params.departmentId, params.workplaceId));
        dispatch(actions.getWorkplaceDailyreportStats(params.workplaceId))
        actions.getPrevInvoices(this.props.params.workplaceId)
            .then((e) => {
                this.setState({
                    prev: e
                })
            })
    };
    renderDatepicker = () => {
        return (
            <div style={{ width: 300, paddingTop: 10, alignSelf: 'flex-end' }}>
                <div style={{ border: '2px solid lightgrey', padding: 10 }}>
                    <h3 style={{ paddingBottom: 10 }}>
                        Periode
                </h3>
                    <DatePickerRange
                        dates={this.props.dates}
                        onChange={(start, end) => {
                            let dateFrom = JSON.parse(JSON.stringify(start));
                            let dateTo = JSON.parse(JSON.stringify(end));
                            if (this.props.dates.start != dateFrom || this.props.dates.end != dateTo) {
                                this.props.dispatch(actions.getPCalcAndDailyreports(dateFrom, dateTo, this.props.params.workplaceId))
                            }
                        }}
                    />
                    <div style={{ paddingTop: 5, paddingLeft: 5 }}>
                        <div
                            style={{ color: semanticColors.info, cursor: 'pointer', textDecoration: 'underline' }}
                            onClick={() => this.props.dispatch(actions.selectNonInvoicedDailyreportsPeriod(this.props.params.workplaceId))}
                        >

                            Alle ikke-fakturerede dagrapporter
                        </div>
                        <div
                            style={{ color: semanticColors.info, cursor: 'pointer', textDecoration: 'underline' }}
                            onClick={() => this.props.dispatch(actions.selectApprovedDailyreportsPeriod(this.props.params.workplaceId))}
                        >

                            Alle godkendte dagrapporter
                        </div>
                        <div
                            style={{ color: semanticColors.info, cursor: 'pointer', textDecoration: 'underline' }}
                            onClick={() => this.props.dispatch(actions.selectAllDailyreportsPeriod(this.props.params.workplaceId))}
                        >
                            Alle dagrapporter
                        </div>
                    </div>
                </div>
            </div>
        )
    }

    renderInvoiceStats = () => {
        let invoiceCount = 0
        this.props.dailyreports.forEach((cur) => {
            if (cur.invoiced) {
                invoiceCount++
            }
        })
        const dailyreportCount = this.props.dailyreports.length
        return (
            <div style={{ width: 300, height: '100%', paddingTop: 10 }}>
                <div
                    style={{
                        border: '2px solid lightgrey',
                        minHeight: 70,
                        padding: 10,
                    }}>
                    <div style={{ textAlign: 'center', }}>
                        <div style={{ fontSize: 18, fontWeight: 600 }}>
                            {dailyreportCount + " "}
                        </div>
                        {dailyreportCount == 1 ? 'dagrapport' : 'dagrapporter'}
                    </div>
                    {invoiceCount !== 0 ?
                        <div style={{ textAlign: 'center', }}>
                            <div style={{ fontSize: 18, fontWeight: 600 }}>
                                {invoiceCount}
                            </div>
                            {invoiceCount == 1 ? 'dagrapport' : 'dagrapporter'} markeret som faktureret
                    </div>
                        :
                        null}
                </div>
            </div >
        )
    }

    dateToString = (date) => {
        var days = ["Søndag", "Mandag", "Tirsdag", "Onsdag", "Torsdag", "Fredag", "​​Lørdag"];
        var curr_date = date.getDate();
        var curr_month = date.getMonth() + 1;
        var curr_year = date.getFullYear();
        return days[date.getDay()] + " d." + curr_date + "/" + curr_month + " " + curr_year;
    }

    renderPrev = () => {
        return (
            <div style={{ border: '2px solid lightgrey', padding: 10 }}>
                <h3 style={{ paddingBottom: 10 }}>
                    Tidligere faktura
                </h3>
                {this.props.prevLoading ?
                    <div style={{ opacity: 0.7, textAlign: 'center' }}>
                        <i className="fa fa-spinner fa-spin fa-3x" />
                    </div>
                    : null}
                {this.props.saved ? null :
                    <div
                        key={Math.random()}
                        style={{
                            display: 'flex',
                            flexDirection: 'row',
                            justifyContent: 'space-between',
                            padding: 10,
                            cursor: 'pointer',
                            backgroundColor: '#5AA6C2',
                            color: 'white',
                            borderBottom: '1px solid lightgrey'
                        }}>
                        <div>
                            Ny faktura
                        </div>
                        <div>
                            Igangværende
                        </div>
                    </div>
                }
                {this.state.prev.map((p, index) => {
                    let background = 'white'
                    let color = 'black'
                    if (this.props.selInv === index && this.props.saved) {
                        background = '#5AA6C2'
                        color = 'white'
                    } else if (index === 0 && this.props.selInv === 'john') {
                        background = '#5AA6C2'
                        color = 'white'
                    }
                    if(p.reduxState.indexOf('"deleted":true') !== -1){return null}
                    return (
                        <div
                            onClick={() => {
                                this.props.dispatch(actions.setPrevInvoice(p, index))
                                this.setState({
                                    activeTab: 5
                                })
                            }}
                            key={index}
                            style={{
                                display: 'flex',
                                flexDirection: 'row',
                                justifyContent: 'space-between',
                                padding: 10,
                                cursor: 'pointer',
                                backgroundColor: background,
                                color: color,
                                borderBottom: '1px solid lightgrey'
                            }}>
                            <div>
                                Faktura nr: {this.state.prev.length - (index)}
                            </div>
                            <div>
                                Oprettet: {this.dateToString(new Date(p.createdAt))}
                            </div>
                        </div>
                    )
                })}
            </div>
        )
    }

    renderStamdata = () => {
        return (
            <div style={{ border: '2px solid lightgrey', padding: 10 }}>
                <h3 style={{ paddingBottom: 10 }}>
                    Stamdata
                </h3>
                <HeadingSubtextContainer
                    updateSubtext={(text, index) => this.props.dispatch(actions.updateSubtext_ExtraInfo(text, index))}
                    updateHeading={(text, index) => this.props.dispatch(actions.updateHeading_ExtraInfo(text, index))}
                    addHeadingSubtext={() => this.props.dispatch(actions.addHeadingSubtext_ExtraInfo())}
                    headingSubtexts={this.props.stamdata}
                    noedit
                    ontAllowNewRow
                    headingStyle={{
                    fontSize: 12,
                    fontWeight: 500,
                    paddingLeft: 0
                    }}
                    subtextStyle={{
                        paddingLeft: 10
                    }}
                />
            </div>
        )
    }

    renderUdvidetInfo = () => {
        return (
            <div style={{ borderBottom: '2px solid lightgrey', borderRight: '2px solid lightgrey', borderLeft: '2px solid lightgrey', borderTop: '0px solid lightgrey', padding: 10 }}>
                <h3 style={{ paddingBottom: 10, }}>
                    Udvidet info
                </h3>
                <HeadingSubtextContainer
                    updateSubtext={(text, index) => this.props.dispatch(actions.updateSubtext_ExtraInfo(text, index))}
                    updateHeading={(text, index) => this.props.dispatch(actions.updateHeading_ExtraInfo(text, index))}
                    addHeadingSubtext={() => this.props.dispatch(actions.addHeadingSubtext_ExtraInfo())}
                    headingSubtexts={this.props.extraInfo}
                />
            </div>
        )
    }
    renderPricelists = () => {
        return (
            <div style={{ width: 424, height: 250, padding: 10, border: '2px solid lightgrey' }}>
                <h3>
                    Vælg Prisliste
                </h3>
                <div style={{ height: 250 - 70 }}>
                    <PricelistsList
                        onSelect={(id) => {
                            this.props.dispatch(actions.selectPriceList(id))
                        }}
                        selectedJohn={this.props.selPriceList}
                    />
                </div>
            </div>
        )
    }

    renderInvoiceSummary = () => {
        return (
            <div style={{ padding: 10, border: '2px solid lightgrey', height: 250, justifySelf: 'flex-end' }}>
                <h3 style={{ paddingBottom: 10 }}>
                    Sum
                </h3>
                <InvoiceSummary
                    others={this.props.others}
                    usage={this.props.usage}
                    crew={this.props.employeeHoursCalc.calcs}
                    offers={this.props.offers}
                    measurements={this.props.measurements}
                    activities={this.props.activities}
                    deliveryNotes={this.props.deliveryNotes}
                    invoices={this.props.invoices}
                />
            </div>
        )
    }

    renderTab1 = () => {
        return (
            <div style={styles.invoiceContainer}>
                <div
                    style={{ width: '100%' }}
                >
                    <h1 style={{ paddingBottom: 10, textAlign: 'center' }}>
                        Øvrige
                    </h1>
                    <Offers
                        id={this.props.offersId}
                        rows={this.props.offers}
                        offersKey={this.props.offersKey}
                        update={(index, offer) => this.props.dispatch(actions.updateOfferRow(index, offer))}
                    />
                    <div
                        style={{ float: 'left', paddingTop: 10, paddingLeft: 5 }}
                    >
                        <button
                            onClick={() => this.props.dispatch(actions.addOfferRow())}
                            className={"btn btn-primary waves-btn"}
                        >
                            Tilføj række
                        </button>
                    </div>
                </div>
                <h1 style={{ paddingBottom: 10 }}>
                    Regningsarbejder
                </h1>
                <div
                    style={{
                        width: '100%',
                    }}
                >
                    <h3 style={{
                        paddingBottom: 10
                    }}>
                        Mandskab
                    </h3>
                    <div style={{ width: '100%' }}>
                        <Crew
                            rows={this.props.employeeHoursCalc.calcs}
                            update={(fun, obj) => this.props.dispatch(actions.updateEmployeeFunction(fun, obj))}
                            recalc={() => this.props.dispatch(actions.recalcEmployee())}
                            crewKey={this.props.crewKey}
                        />
                    </div>
                </div>
                <div
                    style={{ width: '100%', paddingTop: 10 }}
                >
                    <h3 style={{ paddingBottom: 10 }}>
                        Aktiviteter
                    </h3>
                    <Activity
                        rows={this.props.activities}
                        activitiesKey={this.props.activitiesKey}
                        update={(index, activity) => this.props.dispatch(actions.updateActivityRow(index, activity))}
                    />
                </div>
                <div
                    style={{ width: '100%', paddingTop: 10 }}
                >
                    <h3 style={{ paddingBottom: 10 }}>
                        Materiel
                    </h3>
                    <Materiel
                        rows={this.props.usage}
                        materiels={this.props.materiels}
                        materielsKey={this.props.usageKey}
                        type="Materiel"
                        update={(materiel, index) => this.props.dispatch(actions.updateMateriel(materiel, index))}
                        productDiscounts={this.props.productDiscounts}
                    />
                </div>
                <div
                    style={{ width: '100%', paddingTop: 10 }}
                >
                    <h3 style={{ paddingBottom: 10 }}>
                        Materiale
                    </h3>
                    <Materiel
                        rows={this.props.usage}
                        materielsKey={this.props.usageKey}
                        materiels={this.props.materiels}
                        type="Materiale"
                        update={(materiel, index) => this.props.dispatch(actions.updateMateriel(materiel, index))}
                        productDiscounts={this.props.productDiscounts}
                    />
                </div>
                <div
                    style={{ width: '100%', paddingTop: 10, paddingBottom: 10 }}
                >
                    <h3 style={{ paddingBottom: 10 }}>
                        Opmåling
                    </h3>
                    <Measurements
                        rows={this.props.measurements}
                        measurementsKey={this.props.measurementsKey}
                        update={(measurement, index) => this.props.dispatch(actions.updateMeasurement(measurement, index))}
                    />
                </div>
                <div
                    style={{ width: '100%', paddingTop: 10, paddingBottom: 10 }}
                >
                    <h3 style={{ paddingBottom: 10 }}>
                        Følgesedler
                    </h3>
                    <DeliveryNotes
                        update={(deliveryNote, index) => this.props.dispatch(actions.updateDeliveryNote(deliveryNote, index))}
                        rows={this.props.deliveryNotes}
                        deliveryNotesKey={this.props.deliveryNotesKey}
                    />
                </div>
                <div
                    style={{ width: '100%', paddingTop: 10, paddingBottom: 10 }}
                >
                    <h3 style={{ paddingBottom: 10 }}>
                        Diverse
                    </h3>
                    <Others
                        id={this.props.othersId}
                        rows={this.props.others}
                        offersKey={this.props.othersKey}
                        update={(index, offer) => this.props.dispatch(actions.updateOthersRow(index, offer))}
                    />
                    <div
                        style={{ float: 'left', paddingTop: 10, paddingLeft: 5 }}
                    >
                        <button
                            onClick={() => this.props.dispatch(actions.addOthersRow())}
                            className={"btn btn-primary waves-btn"}
                        >
                            Tilføj række
                        </button>
                    </div>
                </div>
            </div >
        )
    }

    renderDailyreports = () => {
      let d = this.props.dailyreports ? this.props.dailyreports : []
        return (
            <div
                style={{ paddingBottom: 20 }}>
                {d
                    .sort(function (a, b) {
                        return new Date(b.date) - new Date(a.date);
                    })
                    .map((d, index) => {
                        return (
                            <div key={index}
                                style={{
                                    borderBottom: '2px solid lightgrey',
                                    overflow: 'auto',
                                    padding: 30,
                                }}>
                                <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-around', padding: 8 }}>
                                    <div style={{ minWidth: 70, fontWeight: 600, color: 'grey' }}>
                                        <div>
                                            {d.invoiced ? "Faktureret" : ""}
                                        </div>
                                        <div>
                                            {d.approved ? "Godkendt" : ""}
                                        </div>
                                    </div>
                                    <div >
                                        <span style={{ fontWeight: 600, color: 'black' }}>{index + 1}</span> <span style={{ color: 'grey' }}>/ {this.props.dailyreports.length}</span>
                                    </div>
                                    {this.props.blacklistedDailyreports[d.aggregateId] ?
                                        <div
                                            style={{ width: 70, display: 'flex', flexDirection: 'row', justifyContent: 'center', cursor: 'pointer' }}
                                            onClick={() => {
                                                let n = Object.assign({}, this.props.blacklistedDailyreports)
                                                n[d.aggregateId] = false
                                                this.props.dispatch(actions.updateBlacklistedDailyreports(n))
                                            }}>
                                            <i
                                                className="fa fa-square-o"
                                                style={[styles.check, { paddingLeft: 2 }]}
                                                aria-hidden="true"

                                            ></i>
                                            <div style={{ color: 'rgb(90, 166, 194)' }}>
                                                Vedlæg
                                                </div>
                                        </div>
                                        :
                                        <div
                                            style={{ width: 70, display: 'flex', flexDirection: 'row', justifyContent: 'center', cursor: 'pointer' }}
                                            onClick={() => {
                                                let n = Object.assign({}, this.props.blacklistedDailyreports)
                                                n[d.aggregateId] = true
                                                this.props.dispatch(actions.updateBlacklistedDailyreports(n))
                                            }}>
                                            <i
                                                className="fa fa-check-square-o"
                                                style={styles.check}
                                                aria-hidden="true"

                                            ></i>
                                            <div style={{ color: 'rgb(90, 166, 194)' }}>
                                                Fjern
                                            </div>
                                        </div>
                                    }

                                </div>


                                <div style={{
                                    position: 'absolute'
                                }}>
                                    <button
                                        style={{
                                            borderRadius: 0
                                        }}
                                        onClick={() => {
                                            let url = window.location.href + '/' + d.aggregateId
                                            url = url.replace('invoice', 'dagrapport')
                                            window.open(url, '_blank')
                                        }}
                                        className={"btn btn-default waves-btn"}
                                    >
                                        Rediger
                                        </button>
                                </div>
                                <div style={{
                                    backgroundColor: 'white',
                                    paddingBottom: 50,
                                    paddingRight: 25,
                                    paddingLeft: 25,
                                    paddingTop: 15,
                                }}>

                                    <StaticDailyReport
                                    pics={d.images}
                                        date={new Date(d.date)}
                                        stamdata={this.props.workplace}
                                        workplaceId={this.props.params.workplaceId}
                                        dailyReportId={d.aggregateId}
                                        measurements={d.measurementRegistrations}
                                        deliveryNotes={d.deliveryNotes}
                                        checkInCheckOutMode={d.checkInCheckOutMode}
                                        description={d.description}
                                        remark={d.remark}
                                        employees={d.employeeRegistrations}
                                        activities={d.activityRegistrations}
                                        materiels={this.props.materiels}
                                        materielRegistrations={d.materielRegistrations}
                                    />
                                </div>
                                <div style={{ display: 'flex', justifyContent: 'center' }}>
                                    <div style={{
                                        width: '73%',
                                        backgroundColor: 'rgb(205, 214, 219)',
                                        textIndent: 5,
                                        fontWeight: 600,
                                    }}>
                                        Bemærkning til bygherre
                                    <textarea
                                            placeholder="..."
                                            style={{
                                                '-webkit-appearance': 'none',
                                                display: 'block',
                                                border: 'none',
                                                boxShadow: '0 1px 2px rgba(0,0,0,0.2) inset, 0 -1px 0 rgba(0,0,0,0.05) inset',
                                                height: '55px',
                                                width: '100%',
                                                resize: 'none',
                                                borderRadius: '2px',
                                                paddingLeft: '5px',
                                            }}
                                            value={d.remrem}
                                            onChange={(e) => {
                                                d.remrem = e.target.value
                                            }}
                                        >
                                        </textarea>
                                    </div>
                                </div>
                            </div>)
                    })}
            </div >
        )
    }

    renderImages = () => {
        return (
            <div style={{ height: '100%' }}>
                <Images params={this.props.params}
                    selected={this.props.selectedImages}
                    select={(pic) => this.props.dispatch(actions.updateSelectedImages(pic))}
                    deselect={(pic) => this.props.dispatch(actions.updateSelectedImages(pic))}
                />
            </div>
        )
    }

    renderAttachments = () => {
        return (
            <div>
                <Invoices
                    update={(invoice, index) => this.props.dispatch(actions.updateInvoice(invoice, index))}
                    rows={this.props.invoices}
                    updateBilag={(bilag, index) => this.props.dispatch(actions.updateBilag(bilag, index))}
                />
                <div
                    style={{ float: 'left', paddingTop: 10, paddingLeft: 5 }}
                >
                    <button
                        onClick={() => this.props.dispatch(actions.addInvoiceRow())}
                        className={"btn btn-primary waves-btn"}
                    >
                        Tilføj række
                        </button>
                </div>
            </div>
        )
    }

    onTabbuttonClicked = (key) => {
        this.setState({
            activeTab: key
        })
    }

    render() {
        return (
            <div style={styles.container} >
                {
                    this.props.loading ?
                        <div style={{ position: 'absolute', top: '50%', left: '50%', opacity: 0.7 }}>
                            <i className="fa fa-spinner fa-spin fa-3x" />
                        </div>
                        : null
                }
                < div style={{ height: '6%', float: 'right', paddingRight: 10 }}>
                    <div style={{
                        backgroundColor: '#f1f1f1', '@media print': {
                            'display': 'none'
                        }
                    }}>
                        <Tabbar
                            activeTab={this.state.activeTab}
                            onTabbuttonClicked={this.onTabbuttonClicked}
                            tabs={[
                                'Forside',
                                'Vedlæg dagrapporter',
                                'Opstilling',
                                'Vedlæg billeder',
                                'Vedlæg fakturabilag',
                                'Gennemse',
                            ]} />
                    </div>
                </div>
                <div style={{
                    height: '94%',
                }}>
                    <Scrollbars
                        id={"SCROLLER"}
                        key={this.state.activeTab}
                        style={{ height: '100%', width: '100%', top: 20 }}
                        renderTrackHorizontal={props => <div {...props} className="track-horizontal" style={{ display: "none" }} />}
                        renderThumbHorizontal={props => <div {...props} className="thumb-horizontal" style={{ display: "none" }} />}
                    >
                        {this.state.activeTab === 0 ?
                            <div style={styles.invoiceContainer}>
                                <div style={{ width: 245 }} >
                                    {this.renderStamdata()}
                                </div>
                                <div style={{
                                    display: 'flex',
                                    flexDirection: 'column'
                                }}>
                                    {this.renderPricelists()}
                                    {this.renderDatepicker()}
                                </div>
                                <div
                                    style={{
                                        display: 'flex',
                                        flexDirection: 'column'
                                    }}>
                                    {this.renderInvoiceSummary()}
                                    {this.renderInvoiceStats()}
                                    {this.renderPrev()}
                                </div>
                            </div>
                            : null}
                        {this.state.activeTab === 1 ?
                            this.renderDailyreports()
                            : null}
                        {this.state.activeTab === 2 ?
                            this.renderTab1()
                            : null}
                        {this.state.activeTab === 3 ?
                            this.renderImages()
                            : null}
                        {this.state.activeTab === 4 ?
                            this.renderAttachments()
                            : null}
                        {this.state.activeTab === 5 ?
                            <StaticInvoice
                            invoiceId={this.props.invoiceId}
                                workplaceId={this.props.params.workplaceId}
                                workplace={this.props.workplace}
                                savee={() => {
                                    this.props.dispatch({ type: 'PREV_IS_LOADING', status: true })
                                    setTimeout(() => {
                                        actions.getPrevInvoices(this.props.params.workplaceId)
                                            .then((e) => {
                                                this.setState({
                                                    prev: e
                                                })
                                                this.props.dispatch({ type: 'PREV_IS_LOADING', status: false })
                                            })
                                    }, 3000)
                                }} />
                            : null}
                    </Scrollbars>
                </div >
            </div >
        );
    }
}

const styles = {
    container: {
        width: '100%',
        height: '97%',
        position: 'relative',
        '@media (min-width: 1200px)': {
            position: 'relative',
            marginLeft: 'auto',
            marginRight: 'auto',
            maxWidth: '1170px',
            width: '100%'
        },
    },
    invoiceContainer: {
        display: 'flex',
        flexDirection: 'row',
        flexWrap: 'wrap',
        justifyContent: 'space-around',
        padding: 10,
    },
    check: {
        paddingTop: 4,
        paddingRight: 5,
    },
}

const selectProps = state => {
    return {
        workplace: state.workplaceOverviewReducer.workplace,
        ...state.InvoiceReducer,
    };
}

export default connect(selectProps)(Radium(Invoice));



// WEBPACK FOOTER //
// ./src/App/ShortTermProjects/Workplace/Invoice/index.js